// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarBetaContext = /*#__PURE__*/createContext(false);
export const useToolbarBetaContext = () => useContext(ToolbarBetaContext);
const ToolbarBetaProvider = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/_jsx(ToolbarBetaContext.Provider, {
    value: true,
    children: children
  });
};
export default ToolbarBetaProvider;